import cookies from "vue-cookies";
import axios from "@common/js/axios";
import store from "@common/js/store";

export const isCookieEnable = () => {
	try {
		var _ = window.top.Window;
		return true;
	} catch (e) {
		return false;
	}
};

export const setTokens = (userName, config) => {
	const accessTokenKey = userName + "AccessToken" + window.location.port;
	const refreshTokenKey = userName + "RefreshToken" + window.location.port;
	const tokenKey = userName + "Token" + window.location.port;
	if (isCookieEnable()) {
		cookies.set(accessTokenKey, config.AccessToken, { path: "/" });
		cookies.set(refreshTokenKey, config.RefreshToken, { path: "/" });
		cookies.set(tokenKey, config.Token, { path: "/" });
	} else {
		window[accessTokenKey] = config.AccessToken;
		window[refreshTokenKey] = config.RefreshToken;
		window[tokenKey] = config.Token;
	}
};

export const removeTokens = (userName) => {
	const accessTokenKey = userName + "AccessToken" + window.location.port;
	const refreshTokenKey = userName + "RefreshToken" + window.location.port;
	const tokenKey = userName + "Token" + window.location.port;
	if (isCookieEnable()) {
		cookies.remove(accessTokenKey);
		cookies.remove(refreshTokenKey);
		cookies.remove(tokenKey);
	} else {
		window[accessTokenKey] = null;
		window[refreshTokenKey] = null;
		window[tokenKey] = null;
	}
};

export const getTokens = (userName) => {
	const accessTokenKey = userName + "AccessToken" + window.location.port;
	const refreshTokenKey = userName + "RefreshToken" + window.location.port;
	const tokenKey = userName + "Token" + window.location.port;
	if (isCookieEnable()) {
		return {
			refreshToken: cookies.get(refreshTokenKey),
			accessToken: cookies.get(accessTokenKey),
			token: cookies.get(tokenKey),
		};
	} else {
		return {
			refreshToken: window[refreshTokenKey],
			accessToken: window[accessTokenKey],
			token: window[tokenKey],
		};
	}
};

export const isKey = (userName, name) => {
	const key = userName + name + window.location.port;
	if (isCookieEnable()) {
		return cookies.isKey(key);
	} else {
		return window[key] != null;
	}
};

export const getUserAuth = (userName) => {
	return axios({
		method: "post",
		url: "Authority/GetUserAuth",
		data: {
			Name: userName,
		},
	}).then((res) => {
		if (res.IsSuccess) {
			store.commit("setUserAuth", { userAuth: res.Result });
			return res.Result;
		}
	});
};

export const getGraphSetting = async () => {
	const res = await axios({
		method: "get",
		url: "Component/config",
		showError: false
	}).catch(() => { });
	if (res?.IsSuccess) {
		res.Result.UseRecorder = await getDiluteConfig();
		store.commit("setGraphSetting", {
			graphSetting: res.Result,
		});
		return res.Result;
	}
};

const getDiluteConfig = async () => {
	const res = await axios({
		method: "get",
		url: "DiluteConfig",
	});
	if (res.IsSuccess && res.Result) {
		return res.Result.Enabled;
	}
	return false;
};
